import styled from 'styled-components';
import { Label } from 'reactstrap';
import { lightGrey2Color } from 'js/config/style';

export default styled(Label)`
  font-weight: normal;
  float: ${({ float }) => float || 'none'};
  font-size: 0.8rem;
  color: ${lightGrey2Color};
`;
